import { BasicRequest } from "./basicRequest";

export class ResetPasswordTokenRequest extends BasicRequest{
    
    public email! : string;

    constructor(){
        super();
    }
}